export var getDateTimeMask = function getDateTimeMask(val, enableTimePicker) {
  var digits = (val.match(/\d+/g) || []).join('');
  var alphabet = (val.match(/[a|p|m]/g) || []).join('');
  var days = digits.slice(0, 2).padEnd(2, 'D');
  var months = digits.slice(2, 4).padEnd(2, 'M');
  var years = digits.slice(4, 8).padEnd(4, 'Y');
  if (enableTimePicker) {
    var hours = digits.slice(8, 10).padEnd(2, 'H');
    var minutes = digits.slice(10, 12).padEnd(2, 'M');
    var mode = alphabet.slice(0, 2).padEnd(2, 'X');
    return "".concat(days, ".").concat(months, ".").concat(years, " ").concat(hours, ":").concat(minutes, " ").concat(mode);
  }
  return "".concat(days, ".").concat(months, ".").concat(years);
};